import { UserServiceClient } from 'fitbeat.api-clients';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { Button, ButtonTypes } from '../components';
import { getApiConfig } from '../config';
import Theme from '../theme';
import { showMessage } from '../ui';
import { AuthTokenBuilder } from '../utils/authTokenBuilder';
import { Logger } from '../utils/Logger';
import { defaultScale } from '../utils/scaling';

interface IState {
  isLoading: boolean;
}

interface IProps {
  navigation: any;
}

class DeleteMyAccountScreen extends Component<IProps, IState> {
  private state = {
    isLoading: false,
  };

  public requestAccountDeletion = async () => {
    const {
      t,
    } = this.props;
    try {
      this.setState({
        isLoading: true,
      });
      const message = t('accountDeletionRequested');
      const userServiceClient = new UserServiceClient(
        getApiConfig(),
        fetch, null,
        new AuthTokenBuilder());
      Logger.notify(new Error(message));
      await userServiceClient.contactUs(message);
      showMessage(message);
      this.props.navigation.goBack();
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  public render() {
    const {
      t,
    } = this.props;
    return (
      <View style={styles.container}>
        <View style={styles.messageContainer}>
          <Text style={styles.header}>{t('deleteAccountHeader')}</Text>
          <Text style={styles.description}>
            {t('deleteAccountMessage')}
        </Text>
          <View style={styles.buttonContainer}>
            <Button
              title={t('deleteAccountButton')}
              fontColor={Theme.WHITE}
              onPress={this.requestAccountDeletion}
              containerStyle={{ padding: 10 }}
              buttonType={ButtonTypes.NORMAL}
              isLoading={this.state.isLoading}
            />
          </View>
        </View>
      </View>);
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.WHITE,
  },
  header: {
    ...Theme.textStyle.heading,
    paddingBottom: defaultScale(10),
    color: Theme.BLACK,
  },
  description: {
    ...Theme.textStyle.bodyCopyReg,
    paddingBottom: defaultScale(13),
    color: Theme.GREY_DARK_MEDIUM,
  },
  messageContainer: {
    justifyContent: 'center',
    flex: 1,
    padding: 40,
  },
  buttonContainer: {
    width: defaultScale(200),
    marginTop: defaultScale(12),
  },
});

export const DeleteMyAccount = translate(['contactUs'], { wait: true })(DeleteMyAccountScreen);
